export default __webpack_public_path__ + "static/media/Asset 5.ad7443dc.svg";